import React, {
  useState,
  useEffect
} from 'react';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import {
  Chip,
  Collapse,
  Badge,
  Paper,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  StepContent,
  Typography,
  Divider,
  Button,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  colors,
} from '@material-ui/core';
import AdjustOutlinedIcon from '@material-ui/icons/AdjustOutlined';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import {
  DocumentView,
  StatusChip,
  ProfileChip,
  DateTimeView,
  EventItem,
  UserComment
} from '../singles';

import {
  ThesisUGBGradingReviewViewer
} from '../../thesis/singles/ThesisUGBGradingReviewViewer';

import localization from '../../../utils/localizations';

import {
  Document,
  User,
  Room,
  Schedule,
  History,
  ThesisUGBReview,
} from '../../../types';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  pageTitle: {
    marginTop: 10,
    marginBottom: 10,
  },
  marginRight: {
    marginRight: 10,
  },
  marginTop: {
    marginTop: 10,
  },
  statusReason: {
    whiteSpace: 'pre-wrap',
  },
  reasonContainer: {
    paddingLeft: 10,
    borderLeft: "solid 2px",
    borderLeftColor: colors.blue[500],
  },
  inlineBlock: {
    display: 'inline-block',
  }
}));

function StatusTimeline(props: {history: History[]; collapsed?: boolean; hideIfEmpty?: boolean;}) {
  const classes = useStyles();
  const [isCollapsed, setIsCollapsed] = useState(props.collapsed ? true : false);

  const reversedHistory = Object.assign([], props.history).reverse();

  if (props.hideIfEmpty && reversedHistory.length === 0) return (<div />);

  return (
    <Paper className={classes.mainBody}>
      <ListSubheader style={{paddingLeft: 8}}>{localization.statusHistory}</ListSubheader>

      <Collapse in={isCollapsed}>
        <Badge badgeContent={reversedHistory.length} color="secondary">
          <Button variant="contained" size="small" onClick={() => setIsCollapsed(false)}>{localization.show}</Button>
        </Badge>
      </Collapse>
      <Collapse in={!isCollapsed}>
        {!isCollapsed &&
        <Stepper orientation="vertical">
        {props.history && reversedHistory.map((historyItem: History, i: number) => {
          return (
            <Step key={`status-${i}`} active>
              <StepLabel StepIconComponent={AdjustOutlinedIcon}>
                {historyItem.created_by && <ProfileChip profile={historyItem.created_by} size="small" className={classes.marginRight} />}
                <StatusChip status={historyItem.status ? historyItem.status : 'updated'} size="small" className={classes.marginRight} />
                <DateTimeView
                  value={historyItem.created_at}
                  fromNow
                  chip
                  size="small"
                />
              </StepLabel>
              <StepContent>
                {historyItem.reason &&
                  <div className={classes.reasonContainer}>
                    <Typography className={classes.statusReason}>{historyItem.reason}</Typography>
                  </div>
                }
                {historyItem.comment &&
                <div className={classes.marginTop}>
                  <Typography variant="subtitle2">{localization.comment}</Typography>
                  <UserComment
                    comment={historyItem.comment}
                    inline
                  />
                </div>
                }
                {historyItem.documents.length > 0 &&
                <List subheader={<Typography variant="subtitle2">{localization.documents}</Typography>} className={classes.marginTop}>
                  {historyItem.documents.map((doc: Document, j: number) => {
                    return (
                      <ListItem key={`doc-dowload-${i}-${j}`}>
                        <DocumentView doc={doc} />
                      </ListItem>
                    );
                  })}
                </List>
                }
                {historyItem.schedules.length > 0 &&
                <List subheader={<Typography variant="subtitle2">{localization.schedule}</Typography>} className={classes.marginTop}>
                  {historyItem.schedules.map((event: Schedule, j: number) => {
                    return (
                      <EventItem
                        key={`history-event-${j}`}
                        event={event}
                      />
                    );
                  })}
                </List>
                }
                {historyItem.thesisugbreview_set.length > 0 &&
                <List subheader={<Typography variant="subtitle2">{localization.review}</Typography>} className={classes.marginTop}>
                  {historyItem.thesisugbreview_set.map((ugbReviewId: string, j: number) => {
                    return (
                      <UGBReviewHistoryItem ugbReviewId={ugbReviewId} buttonLabel={`${localization.show} ${localization.review} #${j+1}`} reviewerName={`Reviewer #${j+1}`} />
                    );
                  })}
                </List>
                }
              </StepContent>
            </Step>
          );
        })}
        </Stepper>}
        <Button onClick={() => setIsCollapsed(true)}>{localization.close}</Button>
      </Collapse>
    </Paper>
  );
}

function UGBReviewHistoryItem(props: {ugbReviewId: string; buttonLabel: string; reviewerName: string;}) {
  const classes = useStyles();
  const [review, setReview] = useState(undefined as ThesisUGBReview|undefined);
  const [showReview, setShowReview] = useState(false);

  if (!showReview) {
    return (
      <Button
        onClick={() => {
          setShowReview(true);
        }}
      >{props.buttonLabel}</Button>
    )
  }

  return <ThesisUGBGradingReviewViewer reviewId={props.ugbReviewId} reviewerName={props.reviewerName} />;
}

export {StatusTimeline};